import { IonCheckbox, IonLabel } from '@ionic/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import { trpc } from '../../modules/trpc'
import { SecondaryHeatingSlideStateType } from '../types/types'
import { secondaryHeatingOptions } from './OnboardingTypeOptions'

interface Props {
	state: [
		SecondaryHeatingSlideStateType,
		React.Dispatch<React.SetStateAction<SecondaryHeatingSlideStateType>>,
	]
	onClick?: () => void
}

const SecondaryHeatingSlide: React.FC<Props> = ({ state, onClick }) => {
	const object = useContext(ObjectContext)
	if (!object) return null

	const { t, i18n } = useTranslation('pages_onboarding')

	const { mutate: updateObject } = trpc.objects.edit.useMutation({})

	const handleCheckboxChange = async (value: string, checked: boolean) => {
		if (onClick) {
			// If onClick is provided, don't update the object directly
			state[1]((currentState: any) => {
				if (checked) {
					return [...currentState, value]
				} else {
					return currentState.filter((item: any) => item !== value)
				}
			})
			return
		}

		try {
			updateObject({
				id: object.id,
				data: { [value]: checked },
			})

			state[1]((currentState: any) => {
				if (checked) {
					return [...currentState, value]
				} else {
					return currentState.filter((item: any) => item !== value)
				}
			})
		} catch (error) {
			console.error('Failed to update heating option', error)
		}
	}

	return (
		<>
			<h1 className='text-text-dark dark:text-white'>
				{t('secondaryHeatingSlide.muitaLammitystapoja')}
			</h1>
			<div className='options-container'>
				{secondaryHeatingOptions(i18n.language as 'fi' | 'en').map(element => (
					<div key={element.value} className='option'>
						<IonCheckbox
							className='dark:[--border-color:#3cb49f] dark:[--border-color-checked:#3cb49f] dark:[--checkbox-background-checked:#3cb49f] dark:[--checkbox-background:#144448] [--border-color:#52ae32] [--border-color-checked:#52ae32] [--checkbox-background-checked:#52ae32] [--checkbox-background:#cae3cc]'
							checked={state[0].includes(element.value)}
							onIonChange={e => handleCheckboxChange(element.value, e.detail.checked)}
						/>
						<IonLabel className='text-text-dark dark:text-white'>{element.label}</IonLabel>
					</div>
				))}
			</div>
		</>
	)
}

export default SecondaryHeatingSlide
